import { gql } from "@apollo/client";

import {
  PRINT_USER_PROFILE_FIELDS,
  USER_REPORT_PRINT_EXTENSION_FIELDS,
  USER_RESULT_PRINT_CORE_FIELDS
} from "@/components/reports/print/fragments";

import { REPORT_FIELDS, USER_REPORT_FIELDS } from "./queries";

export const PATIENT_USER_REPORT_PRINT_QUERY = gql`
  query PatientUserReportPrintQuery(
    $subsectorSlug: String!
    $organisationId: ID!
    $userId: ID!
  ) {
    report(slug: $subsectorSlug, userId: $userId, organisationId: $organisationId) {
      ...ReportFields
    }
    userReport(subsectorSlug: $subsectorSlug, organisationId: $organisationId, userId: $userId) {
      ...UserReportFields
      ...UserReportPrintExtensionFields
    }
    user(userId: $userId, organisationId: $organisationId) {
      ...PrintUserProfileFields
    }
  }
  ${REPORT_FIELDS}
  ${USER_REPORT_FIELDS}
  ${USER_REPORT_PRINT_EXTENSION_FIELDS}
  ${PRINT_USER_PROFILE_FIELDS}
`;

export const PATIENT_USER_RESULT_PRINT_DETAILS_QUERY = gql`
  query PatientUserResultPrintDetailsQuery(
    $userResultId: ID!
    $userId: ID!
    $organisationId: ID!
  ) {
    userResult(userResultId: $userResultId, userId: $userId, organisationId: $organisationId) {
      ...UserResultPrintCoreFields
      untestedDnaDatapoints(organisationId: $organisationId, userId: $userId) {
        id
        name
      }
      untestedDatapoints(organisationId: $organisationId, userId: $userId) {
        id
        name
        description
        function
        reason
        advertisedTestProductName
      }
    }
  }
  ${USER_RESULT_PRINT_CORE_FIELDS}
`;
